var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-top"},[_c('div',{staticClass:"badge m-b-12"},[_vm._v("피드백하기")]),_c('h1',{staticClass:"title m-b-8",domProps:{"innerHTML":_vm._s(_vm.title)},on:{"click":_vm.onClick}}),(_vm.description)?_c('p',{staticClass:"desc m-b-40",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }